var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactivateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.267 38.1261L5.26811 38.2691C0.555578 38.2904 -1.34842 35.0019 1.01531 30.9251L17.1764 3.05201C19.5401 -1.02479 23.3577 -1.01626 25.7044 3.07121L41.5529 30.6872C43.8985 34.7747 41.9796 38.1048 37.267 38.1261ZM21.2404 27.6408C20.0617 27.6408 19.107 28.5965 19.107 29.7741C19.107 30.9517 20.0628 31.9075 21.2404 31.9075C22.418 31.9075 23.3737 30.9517 23.3737 29.7741C23.3737 28.5965 22.418 27.6408 21.2404 27.6408ZM21.2404 25.5075C22.418 25.5075 23.3737 24.5517 23.3737 23.3741V14.8408C23.3737 13.6632 22.418 12.7075 21.2404 12.7075C20.0628 12.7075 19.107 13.6632 19.107 14.8408V23.3741C19.107 24.5528 20.0628 25.5075 21.2404 25.5075Z",
    fill: "#FFAB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateIcon);
export default __webpack_public_path__ + "static/media/DeactivateIcon.69ee959725ef466c47998594839e256e.svg";
export { ForwardRef as ReactComponent };